import { Button } from "components/Button"
import { ConfirmButton } from "components/ConfirmButton"
import { useTranslator } from "components/Translator"
import { UserTimes } from "components/Icon/UserTimes"
import { Text } from "components/Text"
import { useConnectedUser } from "components/ConnectedUserProvider"
import { User, UserPlus, UserSlash } from "components/Icon"
import { getContactBetweenUsers } from "domains/user/model"
import * as ContactType from "enums/ContactType"
import { useAsync } from "@react-hook/async"

export const ManageContactActions = ({
  user,
  onDelete,
  onBlock,
  onUnblock,
}) => {
  const connectedUser = useConnectedUser()
  const contact = connectedUser
    ? getContactBetweenUsers(connectedUser, user)
    : null

  const translator = useTranslator()

  const [blockUserRequest, blockUser] = useAsync(async (user) => {
    await connectedUser.addContact(user.id, ContactType.BLOCKED)

    if (onBlock) {
      onBlock()
    }
  })

  const [unblockUserRequest, unblockUser] = useAsync(async (contactId) => {
    await connectedUser.deleteContact(contactId)

    if (onUnblock) {
      onUnblock()
    }
  })

  const [removeContactRequest, removeContact] = useAsync(async (contactId) => {
    await connectedUser.deleteContact(contactId)

    if (onDelete) {
      onDelete()
    }
  })

  const [addContactRequest, addContact] = useAsync((userId) =>
    connectedUser.addContact(userId),
  )

  const isLoading = [
    blockUserRequest,
    unblockUserRequest,
    addContactRequest,
    removeContactRequest,
  ].some((request) => request.status === "loading")

  return (
    <div className="flex flex-col space-y-4">
      {contact ? (
        <>
          {contact.type === ContactType.BLOCKED ? (
            <Button
              type="button"
              variant="outline"
              color="secondary"
              iconLeft={<User className="w-4" />}
              disabled={isLoading}
              busy={unblockUserRequest.status === "loading"}
              onClick={() => unblockUser(contact.contact_id)}
            >
              {translator.trans(
                "ProfilePage.manageContact.unblock",
                null,
                "components",
              )}
            </Button>
          ) : (
            <Button
              type="button"
              variant="outline"
              color="secondary"
              iconLeft={<UserTimes className="w-4" />}
              disabled={isLoading}
              busy={removeContactRequest.status === "loading"}
              onClick={() => removeContact(contact.contact_id)}
            >
              {translator.trans(
                "ProfilePage.manageContact.remove",
                null,
                "components",
              )}
            </Button>
          )}
        </>
      ) : connectedUser ? (
        <>
          <Button
            type="button"
            variant="outline"
            color="secondary"
            iconLeft={<UserPlus className="w-4" />}
            disabled={isLoading}
            busy={addContactRequest.status === "loading"}
            onClick={() => addContact(user.id)}
          >
            {translator.trans(
              "ProfilePage.manageContact.add",
              null,
              "components",
            )}
          </Button>
          <ConfirmButton
            variant="outline"
            color="secondary"
            iconLeft={<UserSlash className="w-4" />}
            confirmTitle={translator.trans(
              "ProfilePage.manageContact.blockModal.confirmTitle",
              null,
              "components",
            )}
            confirmContent={
              <Text tag="p">
                {translator.trans(
                  "ProfilePage.manageContact.blockModal.confirmContent",
                  null,
                  "components",
                )}
              </Text>
            }
            confirmLabel={translator.trans(
              "ProfilePage.manageContact.blockModal.confirmLabel",
              null,
              "components",
            )}
            onConfirm={() => blockUser(user)}
          >
            {translator.trans(
              "ProfilePage.manageContact.blockModal.confirmTitle",
              null,
              "components",
            )}
          </ConfirmButton>
        </>
      ) : null}
    </div>
  )
}
